module.exports = __webpack_public_path__ + "img/logovp3_LW36.c19d90ea.svg";